export default "__VITE_ASSET__BkbrOFhx__"